<template>
    <div class="row" :class="[{'is-tight': tight, 'is-plain': plain}, reverseStyle]">
        <slot/>
    </div>
</template>

<script>
export default {
        name: "Row",

        props: {
            // Whether the row's columns shall retrieve a tight spacing
            tight: {
                type: Boolean,
                default: false,
            },

            // Whether the row's columns shall retrieve no spacing
            plain: {
                type: Boolean,
                default: false,
            },

            // A breakpoint at which and above to reverse the direction of the row's columns
            reverse: {
                type: String,
                default: null,
            },
        },

        computed: {
            reverseStyle() {
                switch (this.reverse) {
                    case 'sm':
                        return 'sm:row-reverse';
                    case 'md':
                        return 'md:row-reverse';
                    case 'lg':
                        return 'lg:row-reverse';
                    case 'xl':
                        return 'xl:row-reverse';
                }
                return null;
            }
        }
    }
</script>

<style>
.app .row {
  display: grid;
  column-gap: 24px;
  grid-template-columns: repeat(12, 1fr);
}
.app .row.is-tight {
  column-gap: 12px;
}
.app .row.is-plain {
  column-gap: 0;
}
@media (min-width: 640px) {
  .app .row.sm\:row-reverse {
    direction: rtl;
  }
  .app .row.sm\:row-reverse * {
    direction: ltr;
  }
}
@media (min-width: 768px) {
  .app .row.md\:row-reverse {
    direction: rtl;
  }
  .app .row.md\:row-reverse * {
    direction: ltr;
  }
}
@media (min-width: 1024px) {
  .app .row.lg\:row-reverse {
    direction: rtl;
  }
  .app .row.lg\:row-reverse * {
    direction: ltr;
  }
}
@media (min-width: 1280px) {
  .app .row.xl\:row-reverse {
    direction: rtl;
  }
  .app .row.xl\:row-reverse * {
    direction: ltr;
  }
}
</style>